import { render, staticRenderFns } from "./homeCard.vue?vue&type=template&id=4a0a6622&"
import script from "./homeCard.vue?vue&type=script&lang=js&"
export * from "./homeCard.vue?vue&type=script&lang=js&"
import style0 from "./homeCard.vue?vue&type=style&index=0&id=4a0a6622&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports